<template>
  <li class="car-item">
    <router-link
      :to="{
        name: isDealerMicroSite ? 'dealerDetails' : 'car',
        params: {
          carId: carData.pk,
          dealerName: $route.params.dealerName,
          redirectByClick: true
        }
      }"
      tag="div"
    >
      <div class="header">
        <div
          class="header__image"
          :style="{
            backgroundImage: `url(${carData.image || carImagePlaceholder})`
          }"
          role="img"
          aria-label="Car image"
          :title="generateName"
        />
        <base-price-badges
          class="header__price"
          :car-price="carData.price"
          :monthly-price="carData.monthly_hp"
          @click.native.prevent
        />
      </div>
      <div class="info">
        <base-car-details
          :name="generateName"
          :gearbox="$store.getters.decodeGearboxCode(carData.gearbox)"
          :fuel="carData.fuel"
          :mileage="generateMileage"
          :body="carData.body"
        />
        <base-location
          :name="carData.seller.name"
          :address="carData.seller.address1"
          :town="carData.seller.town"
        />
      </div>
    </router-link>
    <base-phone class="phone" :tel="carData.seller.contact_phone" />
  </li>
</template>

<script>
import { mapGetters } from "vuex";

import { addSpacesToNumber } from "@/utils";
import BasePriceBadges from "@/components/ui/BasePriceBadges/BasePriceBadges.vue";
import BaseCarDetails from "@/components/ui/BaseCarDetails/BaseCarDetails.vue";
import BaseLocation from "@/components/ui/BaseLocation/BaseLocation.vue";
import BasePhone from "@/components/ui/BasePhone/BasePhone.vue";

export default {
  name: "CarItem",
  components: {
    BasePriceBadges,
    BaseCarDetails,
    BaseLocation,
    BasePhone
  },
  props: {
    carData: {
      type: Object,
      require: true,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(["isDealerMicroSite", "dealerName"]),
    carImagePlaceholder: () => require("@/assets/images/cars/placeholder.png"),
    generateName() {
      return `
        ${this.carData.year}
        ${this.carData.make}
        ${this.carData.model}
        ${this.carData.body}
      `;
    },
    generateMileage() {
      return `
        ${addSpacesToNumber(this.carData.mileage)}
        ${this.carData.mileageunits}
      `;
    }
  }
};
</script>

<style scoped lang="scss">
.car-item {
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 40px 0 rgba(0, 0, 0, .1);
  }
}

.header {
  position: relative;
  background-color: $color-grey-200;

  &__image {
    width: 100%;
    min-height: 250px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__price {
    position: absolute;
    bottom: 0;
  }
}

.info {
  padding: 25px 20px;
}

.phone {
  padding: 0 20px 25px;
}

@media screen and (min-width: $media-m) {
  .header .header__image {
    min-height: 600px;
  }
}

@media screen and (min-width: $media-l) {
  .header .header__image {
    min-height: 300px;
  }
}

@media screen and (min-width: $media-xl) {
  .header .header__image {
    min-height: 280px;
  }
}

@media screen and (min-width: $media-xxxl) {
  .info {
    padding: 45px 25px;
  }

  .header .header__image {
    min-height: 350px;
  }
}
</style>
